import { initializeCarousels } from './carousel';
import { initAutocomplete } from './global-autocomplete';
import { initializeSearchBar } from './search';
import { SvgSprite } from './svg-loader';
import { initializePopups } from '../FeaturedItems/featured-popup';
import { initializeMeganavs } from './meganav';
import { initializeQuickorder } from './quickorder';
import { initializeCartCounts } from './cart';
import { initializeAccountSummary } from './account-summary';
import { initializeStickyNavResize } from './sticky-nav';
var objectFitVideos = require('object-fit-videos');

window.addEventListener("DOMContentLoaded", () => {
    initializeCarousels();
    initAutocomplete();
    initializeSearchBar();
    initializePopups();
    initializeQuickorder();
    initializeMeganavs();
    initializeCartCounts();
    initializeAccountSummary();
    initializeStickyNavResize();

    // SVG Sprite Inject
    new SvgSprite('/Site/Ellsworth/Static/img/adage-sprite.svg');

    objectFitVideos(document.querySelectorAll('[data-object-fit]'));
});